import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { StyledDiv as AuthorBio } from "~/components/author/author-bio/styles";
import { StyledEntityLink as AuthorName } from "~/components/author/author-name/styles";
import { SocialLink } from "~/components/author/author-social-links/styles";

import { AuthorCardContainer } from "./author-card/default-author-card/styles";
import { StyleAuthorCardContainer as PlusAuthorCardContainer } from "./author-card/plus-author-card/styles";
export type AuthorCardsContainerProps = {
  $variant?: "light" | "dark" | "magazines-style" | "plus";
};
export const AuthorCardsContainer = styled.div<AuthorCardsContainerProps>`
  ${AuthorCardContainer} + ${AuthorCardContainer} {
    margin-block-start: 20px;
    padding-block-start: 20px;
    border-block-start: 1px solid #f2f2f2;
  }

  ${AuthorBio}, ${AuthorName}, ${SocialLink} {
    ${props =>
      props.$variant === "dark"
        ? css`
            color: #ffffff;

            fill: #ffffff;
          `
        : null}
  }
`;

export const PlusAuthorCardsContainer = styled.div`
  padding: 20px;

  border-radius: 4px;

  background: #c8ced566;

  ${PlusAuthorCardContainer} {
    &:not(:last-child) {
      margin-block-end: 16px;
      padding-block-end: 16px;
      border-block-end: 1px solid #b2b2b2;
    }
  }
`;
